import React from 'react';
import DashboardStaff from './DashboardStaff';

/**
 * Dashboard para administradores: estadísticas de tickets + accesos
 * a gestión de tickets, usuarios y tracking de proyectos.
 */
const DashboardAdmin = ({ tokenInfo, onLinkClick }) => {
  return <DashboardStaff tokenInfo={tokenInfo} onLinkClick={onLinkClick} />;
};

export default DashboardAdmin;
